<template>
  <v-layout>
    <v-flex v-if="!overlay">
      <v-card
          class="mt-12 mb-12"
          shaped
      >
        <v-toolbar
            dark
        >
          <v-app-bar-nav-icon>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                >
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                    link
                    href="/vorbereitung/subjects/create"
                >
                  <v-list-item-title>Erstelle neu</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-app-bar-nav-icon>

          <v-toolbar-title>Fächer</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field
              v-model="queries.s"
              clearable
              flat
              dense
              solo-inverted
              hide-details
              prepend-inner-icon="mdi-magnify"
              label="Suchen"
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-select
              v-model="sortBy"
              flat
              dense
              solo-inverted
              hide-details
              :items="[
                            { text: 'ID', value: 'IDFaecher' },
                            { text: 'Fachname', value: 'FachName' },
                            { text: 'Fachkürzel', value: 'fachkuerzel' }
                        ]"
              prepend-inner-icon="mdi-sort-variant"
              label="Sort by"
          ></v-select>

          <v-spacer></v-spacer>

          <v-btn-toggle
              v-model="sortDesc"
              mandatory
              dense
          >
            <v-btn
                depressed
                :value="false"
            >
              <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn
                depressed
                :value="true"
            >
              <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
          </v-btn-toggle>

          <v-spacer></v-spacer>

          <v-btn-toggle
              v-model="statusFilter"
              mandatory
              dense
          >
            <v-btn
                :value="STATUS_ACTIVE"
                :color="statusFilter === STATUS_ACTIVE ? 'primary' : 'secondary'"
            >
              Aktiv
            </v-btn>
            <v-btn
                :value="STATUS_DEACTIVATED"
                :color="statusFilter === STATUS_DEACTIVATED ? 'primary' : 'secondary'"
            >
              Inaktiv
            </v-btn>
          </v-btn-toggle>
        </v-toolbar>

        <v-card-text class="pa-6 pt-8">
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th>ID</th>
                <th>Fachname</th>
                <th>Fachkürzel</th>
                <th v-if="isFFM">Untis Kürzel</th>
                <th>Schriftliche Prüfung</th>
                <th style="width: 108px"></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="collection.data.length === 0">
                <td class="text-center" colspan="4">No data found.</td>
              </tr>
              <template v-else v-for="subject in collection.data">
                <tr>
                  <td>{{ subject.IDFaecher }}</td>
                  <td>{{ subject.FachName }}</td>
                  <td>{{ subject.fachkuerzel }}</td>
                  <td v-if="isFFM">{{ subject.STP_Kurz }}</td>
                  <td class="text-center">
                    <v-icon v-if="subject.schrPruefung" color="success">mdi-check</v-icon>
                    <v-icon v-else color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-btn
                        :href="`/vorbereitung/subjects/${subject.IDFaecher}/edit/${queries.page}`"
                        icon
                    >
                      <v-icon>mdi-clipboard-edit-outline</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-switch
                        v-model="subject.status"
                        label="Aktiv"
                        color="primary"
                        :true-value="STATUS_ACTIVE"
                        :false-value="STATUS_DEACTIVATED"
                        @change="changeStatus($event, subject)"
                    ></v-switch>
                  </td>
                </tr>
              </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions class="pa-6 pb-8">
          <span class="grey--text">Einträge pro Seite</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  dark
                  text
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
              >
                {{ queries.per_page }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                  v-for="(number, index) in perPageArgs"
                  :key="index"
                  @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">
                        Seite {{ queries.page }} von {{ pageCount }}
                    </span>
          <v-btn
              small
              dark
              color="blue darken-3"
              class="mr-1"
              @click="prevPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
              small
              dark
              color="blue darken-3"
              class="ml-1"
              @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <overlay v-model="overlay"></overlay>
  </v-layout>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, toRefs, watch} from '@vue/composition-api'
import {useStore} from '../../store'
import {SubjectCollection} from '../../store/modules/subject-collection'
import {pageCount} from '../../core/utils/pagination'
import {STATUS_ACTIVE, STATUS_DEACTIVATED, Subject} from '../../core/models/subject'
import {useHttp} from '../../core/http';

export default defineComponent({
  name: 'PageSubjects',

  /**
   * @param props
   */
  setup(props) {
    const state = reactive({
      overlay: true,
      pageCount: 1,
      perPageArgs: [8, 12, 16],
      sortDesc: true,
      sortBy: 'IDFaecher',
      statusFilter: 0,
      isFFM: false
    })

    const queries = reactive({
      s: undefined,
      page: 1,
      limit: 5,
      per_page: 8,
      status: 0,
      sort: '-IDFaecher',
    })

    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('page')) {
      queries.page = Number(urlParams.get('page'));
    }

    const store = useStore()

    const collection = computed(() => <SubjectCollection>store.getters['subjectCollection/get'])

    const fetch = () => {
      store.dispatch('subjectCollection/get', queries).then((data) => {
        state.pageCount = pageCount(data.meta)
        state.overlay = false
      })
      useHttp().get('params?param=appLocation').then((data: any) => {
        state.isFFM = data.data === 'FFM'
      })
    }

    const nextPage = () => {
      if (queries.page + 1 <= state.pageCount) {
        queries.page += 1
        fetch()
      }
    }

    const prevPage = () => {
      if (queries.page - 1 >= 1) {
        queries.page -= 1
        fetch()
      }
    }

    const updateItemsPerPage = (number: number) => {
      queries.per_page = number
      fetch()
    }

    const destroy = (subject: Subject) => {
      if (confirm('Möchten Sie das Element wirklich löschen?')) {
        store.dispatch('subject/delete', {id: subject.IDFaecher}).then(() => {
          fetch()
        })
      }
    }

    const changeStatus = (event: any, subject: Subject) => {
      subject.status = event
      store.dispatch('subject/update', {id: subject.IDFaecher, payload: subject}).then(() => {
        fetch();
      })
    }

    watch(() => [queries.s, state.sortBy, state.sortDesc, state.statusFilter], () => {
      queries.sort = (state.sortDesc ? '-' : '') + state.sortBy
      queries.status = state.statusFilter
      fetch()
    })

    onMounted(() => {
      fetch()
    })

    return {
      queries,
      collection,
      nextPage,
      prevPage,
      updateItemsPerPage,
      destroy,
      changeStatus,
      STATUS_ACTIVE,
      STATUS_DEACTIVATED,
      ...toRefs(state)
    }
  }
})
</script>
